import { media, styled } from '@styles';

export const Wrapper = styled.div`
  width: 50%;
  padding-left: 164px;
  ${media.largeScreen`
    padding-left: 84px;
  `}
  ${media.mediumScreen`
    padding-left: 0;
    padding-bottom: 40px;
  `}
  ${media.smallScreen`
    width: 100%;
    padding-bottom: 20px;
    margin-left: 22px;
  `}
`;

export const Title = styled.h3`
  margin-bottom: 62px;
  font-family: ${(props) => props.theme.typography.thinFontFamily};
  font-size: ${(props) => props.theme.typography.h3FontSize};
  line-height: 110%;
  ${media.largeScreen`
    margin-bottom: 41px;
    line-height: 130%;
  `}
  ${media.mediumScreen`
    text-align: center;
  `}
  ${media.smallScreen`
    margin-bottom: 34px;
  `}
`;
